/** Geometry of the selection-summary anchor — the anchor cell's box relative to the grid wrapper, so one grid-level overlay tracks the cell without remounting. */
export type PivotSummaryAnchor = { top: number; left: number; width: number; height: number }

type PivotSummaryBox = { top: number; left: number; width: number; height: number }

/** The anchor cell's box relative to the grid wrapper's box — both measured in the same viewport frame, so no scroll math is needed. */
export const toPivotSummaryAnchor = (
  cell: PivotSummaryBox,
  grid: { top: number; left: number }
): PivotSummaryAnchor => ({
  top: cell.top - grid.top,
  left: cell.left - grid.left,
  width: cell.width,
  height: cell.height,
})
